import { useState } from "react";

export const ProfileAvatar = ({ url, initials }: {
  readonly url: string | null | undefined;
  readonly initials: string;
}): JSX.Element => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  return url && url !== failedUrl
    ? <img src={url} alt="" onError={() => setFailedUrl(url)}
        style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }} />
    : <>{initials}</>;
};
